import React from "react";
import Grid from "@mui/material/Grid2";
import { useSelector } from "react-redux";
import FallbackTypography from "src/components/shared/FallbackTypography";
import { Typography } from "@mui/material";

const VoucherHeaderDetails = ({entity}) => {
  const { clientVoucherDetails } = useSelector((state) => state.reservationsSummaryReducer);

  return (
    <>
        <Grid container rowSpacing={1} mt={5} ml={7}>
          <Grid size={6}>
            <Grid container direction="row" alignItems="center" spacing={2}>
              <Grid item size={6}>
                <Typography variant="body1" m={1}>
                  To:
                </Typography>
              </Grid>
              <Grid item size={6}>
                <FallbackTypography variant="h6" m={1} value={entity.Name} />
              </Grid>
            </Grid>
            <Grid container direction="row" alignItems="center" spacing={2}>
              <Grid item size={6}>
                <Typography variant="body1" m={1}>
                  Address:
                </Typography>
              </Grid>
              <Grid item size={6}>
                <FallbackTypography variant="h6" m={1} value={entity.Address} />
              </Grid>
            </Grid>
          </Grid>

          <Grid size={6}>
            <Grid container direction="row" alignItems="center" spacing={2}>
              <Grid item size={6}>
                <Typography variant="body1" m={1}>
                  Printed date:
                </Typography>
              </Grid>
              <Grid item size={6}>
                <FallbackTypography variant="h6" m={1} value={clientVoucherDetails.Timestamp} />
              </Grid>
            </Grid>
            <Grid container direction="row" alignItems="center" spacing={2}>
              <Grid item size={6}>
                <Typography variant="body1" m={1}>
                  Tour No:
                </Typography>
              </Grid>
              <Grid item size={6}>
                <FallbackTypography variant="h6" m={1} value={clientVoucherDetails.ReservationNumber} />
              </Grid>
            </Grid>
            <Grid container direction="row" alignItems="center" spacing={2}>
              <Grid item size={6}>
                <Typography variant="body1" m={1}>
                  Voucher No:
                </Typography>
              </Grid>
              <Grid item size={6}>
                <FallbackTypography variant="h6" m={1} value={clientVoucherDetails.VoucherNumber} />
              </Grid>
            </Grid>
            <Grid container direction="row" alignItems="center" spacing={2}>
              <Grid item size={6}>
                <Typography variant="body1" m={1}>
                  Check In:
                </Typography>
              </Grid>
              <Grid item size={6}>
                <FallbackTypography variant="h6" m={1} value={entity.CheckIn} />
              </Grid>
            </Grid>
            <Grid container direction="row" alignItems="center" spacing={2}>
              <Grid item size={6}>
                <Typography variant="body1" m={1}>
                  Check Out:
                </Typography>
              </Grid>
              <Grid item size={6}>
                <FallbackTypography variant="h6" m={1} value={entity.CheckOut} />
              </Grid>
            </Grid>
            <Grid container direction="row" alignItems="center" spacing={2}>
              <Grid item size={6}>
                <Typography variant="body1" m={1}>
                  Confirmation No:
                </Typography>
              </Grid>
              <Grid item size={6}>
                <FallbackTypography variant="h6" m={1} value={entity.ConfirmationNumber} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
    </>
  );
};

export default VoucherHeaderDetails;
